import { Environment } from './model/environment.model';

export const environment: Environment = {
  production: false,
  apiUrl: 'https://apim-psp-backend-staging.azure-api.net/api',
  keycloakUrl: 'https://test.log.wien/auth/',
  keycloakRealm: 'admin',
  keycloakClient: 'client-individualkundenportal-admin-public',
  baseUrl: 'https://staging-berater-unternehmen.wienenergie.at',
  staticContentUrl: 'https://test-static.wienenergie.at/projects/premiumserviceportal/config',
  impersonationUrl: 'https://test.log.wien/kunden-service-app/',
  impersonationTarget: 'KGUcollaborate',
  impersonationTargetUrl: 'https://staging-unternehmen.wienenergie.at/home',
  impersonationCollaborationUrl:
    'https://test.log.wien/rest/logwien/admin/users/{userId}/partners/{partnerName}/services/{serviceName}/impersonation',
  impersonationLogWienService: 'we-ikp',
  impersonationLogWienPartner: 'wien-energie',
  isRegistrationEnabled: false,
};
